import { useMutation } from '@tanstack/react-query';
import { api } from './utils/api-base';
import { AttributionEvent } from '~/shared/types/attribution_event';

export type CreateAttributionEventParams = {
  actor_id?: string | number | null;
  actor_type?: AttributionEvent['actor_type'];
  utm_source?: AttributionEvent['utm_source'];
  utm_medium?: AttributionEvent['utm_medium'];
  utm_campaign?: AttributionEvent['utm_campaign'];
  utm_content?: AttributionEvent['utm_content'];
  utm_term?: AttributionEvent['utm_term'];
  gclid?: AttributionEvent['gclid'];
  gbraid?: AttributionEvent['gbraid'];
  wbraid?: AttributionEvent['wbraid'];
  landing_url?: AttributionEvent['landing_url'];
};

export const useCreateAttributionEvent = () => {
  return useMutation({
    mutationFn: async (attribution_event: CreateAttributionEventParams) => {
      const response = await api.post<AttributionEvent>('/attribution_events', { attribution_event });
      return response.data;
    },
  });
};

export const useAssociateAttributionEventWithUser = () => {
  return useMutation({
    mutationFn: async ({ slug }: { slug: string }) => {
      const response = await api.patch<AttributionEvent>(`/attribution_events/${slug}/associate_with_user`);
      return response.data;
    },
  });
};
